import React from "react";
import { Tooltip } from "../../../../../../components/tooltip/tooltip/tooltip.component";
import { TooltipTitle } from "../../../../../../components/tooltip/tooltip-title/tooltip-title.component";
import { TooltipBody } from "../../../../../../components/tooltip/tooltip-body/tooltip-body.component";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { BASE_COLORS } from "../../../../../../emotion-theme";
import { CachedIcon } from "../../../../../../components/icon/icons/cached-icon.component";
import { ProductsTableStatusIndicatorProps } from "../product-status-indicator/products-table-status-indicator.props";

export const ProductStatusIndicatorTooltipManual = withShowIf(
  (props: ProductsTableStatusIndicatorProps) => (
    <Tooltip colour={BASE_COLORS.orangeText} icon={CachedIcon}>
      <TooltipTitle>{props.field} Manually Overwritten</TooltipTitle>
      <TooltipBody>
        {props.field} has been overwritten after it was overwritten by the system.
      </TooltipBody>
    </Tooltip>
  )
);
